import React from 'react';
import { Typography, IconButton } from '@material-ui/core';
import { ArrowBack, ChevronLeft, ChevronRight, ExpandLessOutlined, ExpandMoreOutlined } from '@material-ui/icons';
import { Box } from "@mui/material";
import { useHistory } from "react-router-dom";
import { tUi } from '../../../../../../../utils/dq_lc';
import SidebarCatalog from './SidebarCatalog.comp';

// Back from the preview goes to the program list — the program dashboard is no
// longer linked (opening a program skips it and lands on the preview).
const PROGRAM_LIST_PATH = '/dq_pro/learning/program/list';

const Sidebar = ({
    data,
    nav,
    plan,
    classes,
    code,
    embedded = false,
    isMobile = false,
    isCollapsed = false,
    toggleCollapse,
    isPublicPreview = false,
    isGuest = false,
    onSignUp,
    onUpgrade,
    onViewOutline,
    setShowOutline,
}) => {
    const history = useHistory();

    return (
        <Box className={embedded ? classes.embeddedLeftContainer : classes.leftContainer} style={{
            height: embedded ? (isMobile ? (isCollapsed ? "0px" : "auto") : "93%") : (isMobile ? (isCollapsed ? "100px" : "82vh") : "82vh"),
            width: !isMobile ? (isCollapsed ? "10%" : "26%") : "100%",
            marginRight: embedded ? 0 : (!isMobile ? "20px" : "auto"),
            padding: embedded ? 0 : (!isMobile ? (isCollapsed ? "6px 4px" : "10px") : "auto"),
            alignItems: isCollapsed && !isMobile ? 'center' : undefined,
            overflowY: 'hidden'
        }}>
            {isCollapsed ? (
                isMobile ? (
                    <Box style={{ width: "100%", padding: "8px 0", display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "space-between" }}>
                        {!isPublicPreview && (
                            <IconButton
                                onClick={() => embedded ? toggleCollapse() : history.push(PROGRAM_LIST_PATH)}
                                disableRipple
                                disableFocusRipple
                                style={{ color: '#0097B2', backgroundColor: 'var(--brand-surface, #fff)', border: '1px solid var(--brand-border, #e6e9ef)', boxShadow: '0 2px 6px rgba(0,0,0,0.06)', cursor: 'pointer', outline: "none" }}
                            >
                                <ArrowBack style={{ fontSize: 22 }} />
                            </IconButton>
                        )}
                        <Typography variant="h4" className={classes.title} style={{ textAlign: "center" }}>
                            {data.sidebarProgramName}
                        </Typography>
                        <IconButton onClick={toggleCollapse} style={{ marginTop: "6px", color: "#ef6528", backgroundColor: "var(--brand-surface, #fff)", border: "1px solid var(--brand-border, #e6e9ef)", boxShadow: "0 2px 6px rgba(0,0,0,0.06)" }}>
                            <ExpandMoreOutlined style={{ fontSize: 22 }} />
                        </IconButton>
                    </Box>
                ) : (
                    <>
                        <IconButton onClick={toggleCollapse} style={{ position: "absolute", top: 10, left: "50%", transform: "translateX(-50%)", color: "#ef6528", backgroundColor: "#fff", border: "1px solid #e6e9ef", boxShadow: "0 2px 6px rgba(0,0,0,0.06)", zIndex: 2, padding: 6 }}>
                            <ChevronRight style={{ fontSize: 22 }} />
                        </IconButton>
                        <Box style={{ flexGrow: 1, display: "flex", alignItems: "center", justifyContent: "center", fontWeight: "bold", color: "#0097B2", padding: "0 10px", cursor: "default" }}>
                            <Typography variant="h4" className={classes.title} style={{ writingMode: "vertical-rl", transform: "rotate(180deg)", textAlign: "center" }}>
                                {data.sidebarProgramName}
                            </Typography>
                        </Box>
                    </>
                )
            ) : (
                <Box className={classes.leftContentContainer} style={{ paddingTop: embedded ? '0px' : '56px', paddingBottom: embedded ? '0px' : '56px', display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
                    {data.loading ? (
                        <Typography>Loading...</Typography>
                    ) : (
                        <>
                            {!embedded && !isCollapsed && (
                                <Box sx={{ position: 'absolute', top: 0, left: 0, right: 0, height: '75px', mb: 4, borderRadius: '8px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '0 8px', backgroundColor: '#ffff', zIndex: 100 }}>
                                    {!isPublicPreview && (
                                        <IconButton onClick={() => history.push(PROGRAM_LIST_PATH)} disableRipple disableFocusRipple style={{ color: '#0097B2', backgroundColor: 'var(--brand-surface, #fff)', border: '1px solid var(--brand-border, #e6e9ef)', boxShadow: '0 2px 6px rgba(0,0,0,0.06)', cursor: 'pointer', outline: "none" }}>
                                            <ArrowBack style={{ fontSize: 22 }} />
                                        </IconButton>
                                    )}
                                    <Typography variant="h4" className={classes.title}>
                                        {data.sidebarProgramName}
                                    </Typography>
                                    <IconButton onClick={toggleCollapse} disableRipple disableFocusRipple style={{ transition: 'all 0.3s ease', zIndex: 99, cursor: 'pointer', outline: "none", color: '#ef6528', backgroundColor: '#ffffff', border: '1px solid #e6e9ef', boxShadow: '0 2px 6px rgba(0,0,0,0.06)' }}>
                                        {isMobile ? <ExpandLessOutlined style={{ fontSize: 22 }} /> : <ChevronLeft style={{ fontSize: 22 }} />}
                                    </IconButton>
                                </Box>
                            )}

                            <SidebarCatalog
                                modulesData={data.modulesData}
                                classes={classes}
                                handleToggleModuleDropdown={data.handleToggleModuleDropdown}
                                tUi={tUi}
                                uiLocale={data.uiLocale}
                                dqcoList={data.dqcoList}
                                handleModuleCodeClick={data.handleModuleCodeClick}
                                dqcoLoadingCode={data.dqcoLoadingCode}
                                popupContent={data.popupContent}
                                setPopupContent={data.setPopupContent}
                                openModules={data.openModules}
                                openUnits={data.openUnits}
                                handleToggleUnitDropdown={data.handleToggleUnitDropdown}
                                selectedSession={data.selectedSession}
                                embedded={embedded}
                                firstSessionCode={plan.firstSessionCode}
                                lockedSessionCodes={plan.lockedSessionCodes}
                                contentStatus={data.contentStatus}
                                handleToggleSessionDropdown={data.handleToggleSessionDropdown}
                                openSessions={data.openSessions}
                                slidesLoading={data.slidesLoading}
                                segments={nav.segments}
                                isSegmentActive={nav.isSegmentActive}
                                assessmentVisibility={data.assessmentVisibility}
                                handleOpenAssessmentModal={data.handleOpenAssessmentModal}
                                handleViewSegment={nav.handleViewSegment}
                                isMobile={isMobile}
                                toggleCollapse={toggleCollapse}
                                onViewOutline={() => {
                                    if (onViewOutline) onViewOutline();
                                    if (setShowOutline) setShowOutline(true);
                                    if (isMobile) toggleCollapse();
                                }}
                                onViewSession={(session) => {
                                    if (setShowOutline) setShowOutline(false);
                                    data.handleToggleSessionDropdown(session);
                                    if (isMobile) toggleCollapse();
                                }}
                                isGuest={isGuest}
                                onSignUp={onSignUp}
                                onUpgrade={onUpgrade}
                                isPublicPreview={isPublicPreview}
                            />
                        </>
                    )}
                </Box>
            )}
        </Box>
    );
};

export const PreviewSidebar = Sidebar;
export { Sidebar };
export default Sidebar;
